import axios, { AxiosInstance } from "axios";
import { AutocompletePlace } from "@Types/addresses";
import { KonnektorApiMondialRelayLocation } from "@Types/api/addresses";
import { getVariableByEnv } from "@Utils/variableByEnv";

export default class KonnektorApiProvider {
  api: AxiosInstance;

  constructor(csrfToken: string) {
    const headers = {
      Accept: "application/json",
      "X-CSRF-TOKEN": csrfToken,
    };

    this.api = axios.create({
      baseURL: getVariableByEnv("REACT_APP_KONNEKTOR_URL"),
      headers,
    });
  }

  async getMondialRelayLocations(
    place: AutocompletePlace
  ): Promise<{ response: KonnektorApiMondialRelayLocation[] }> {
    const url =
      place.position.lat && place.position.lng
        ? `/shipping/v2/mondial_relay?lat=${place.position.lat}&long=${place.position.lng}`
        : place.countryTag && place.postCode
        ? `/shipping/v2/mondial_relay?country_tag=${place.countryTag}&postcode=${place.postCode}`
        : "";

    const { data } = await this.api.get<{ response: KonnektorApiMondialRelayLocation[] }>(url);

    return data;
  }
}
